import { createContext, useContext } from 'react';
import { EMPTY_SYMBOL_CATALOGUE, type PreparedSymbolCatalogue } from '../../../symbols/images';
import { graphicKey } from '../../../symbols/tint';
import type { SymbolGraphic } from '../../../symbols/model';

export const Resources = createContext<PreparedSymbolCatalogue>(EMPTY_SYMBOL_CATALOGUE);
export const ArtworkMetrics = createContext<PreparedSymbolCatalogue>(EMPTY_SYMBOL_CATALOGUE);

/** Original alpha is independent of tint/opacity; retain metrics while presentation variants update. */
export function useSymbolArtworkMetrics(graphic: SymbolGraphic) {
  const images = useContext(ArtworkMetrics);
  return images.get(
    graphicKey(
      graphic,
      typeof graphic !== 'string' && graphic.kind === 'builtin' ? '#334155' : undefined,
    ),
  );
}
